import React, {useEffect, useState} from 'react';
import {queryString} from '../../../Util/commonUtility';
import ChaptersComponent from '../../../Components/AdminComponents/Chapters';
import {useDispatch, useSelector} from 'react-redux';
import {
  deleteChapterById,
  getAllChaptersByQueryString,
} from '../../../Store/Actions';

const ChaptersContainer = () => {
  const dispatch = useDispatch();
  const {allChaptersQueryData} = useSelector(({chapters}) => chapters);
  const [listData, setListData] = useState();
  const [sortParams, setSortParams] = useState({
    field: 'order_number',
    order: 'ascend',
  });
  const searchValues = useSelector(
    ({dynamicSearch}) => dynamicSearch.searchValues.chapters,
  );

  useEffect(() => {
    if (allChaptersQueryData?.forMaster) {
      setListData(allChaptersQueryData?.forMaster?.data?.chapters);
    } else {
      fetchChapters(searchValues, sortParams);
    }
  }, [allChaptersQueryData?.forMaster?.data?.chapters]);

  useEffect(() => {
    if (searchValues) {
      fetchChapters(searchValues, sortParams);
    }
  }, [searchValues]);

  const fetchChapters = async (values, sort = sortParams) => {
    const searchQueryData = queryString(values);
    dispatch(
      getAllChaptersByQueryString(
        sort.field || 'order_number',
        sort.order || 'ascend',
        searchQueryData,
        {page: 1, pageCount: 100},
      ),
    );
  };

  const handleTableChange = (_pagination, _filter, sorter) => {
    // Ant Design clears order on 3rd click; treat that as "normal" (display order).
    const nextSort = !sorter?.order
      ? {field: 'order_number', order: 'ascend'}
      : {field: sorter.field, order: sorter.order};
    setSortParams(nextSort);
    fetchChapters(searchValues, nextSort);
  };

  const DeleteChapters = async (id) => {
    dispatch(deleteChapterById(id));
  };

  return (
    <div>
      <ChaptersComponent
        allChaptersData={listData}
        DeleteChapters={(id) => {
          DeleteChapters(id);
        }}
        fetchChapters={(values) => {
          fetchChapters(values, sortParams);
        }}
        handleTableChange={handleTableChange}
        sortParams={sortParams}
        searchValues={searchValues}
      />
    </div>
  );
};
export default ChaptersContainer;
